import { render } from "./ProveedorList.vue?vue&type=template&id=ef4a7b06&scoped=true"
import script from "./ProveedorList.vue?vue&type=script&lang=js"
export * from "./ProveedorList.vue?vue&type=script&lang=js"

import "./ProveedorList.vue?vue&type=style&index=0&id=ef4a7b06&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef4a7b06"]])

export default __exports__